import { call, put, select } from 'redux-saga/effects';
import { getFormValues } from 'redux-form';
import _get from 'lodash/get';

// Actions
import { ActionTypes } from '../actions/customization/autosave';
import { getCardByVariationUUID } from '../actions/cardCatalogActions';
import api from '../services/api';

// Selectors
import { getCustomizationUUIDByType, getPageNumberByStep, getElementUUIDs, getPage } from '../selectors/Customization';

// Helpers
import customizationElementsMapper from './helpers';

export default function* customizationUpdateSaga() {
  // All required variables to manipulate state and dispatch customization save
  const state = yield select();
  const customizationUUID = yield select(getCustomizationUUIDByType);
  const pageNumber = yield select(getPageNumberByStep);
  const formValues = getFormValues(`${customizationUUID}_${pageNumber}`)(state);
  const elementUUIDs = yield select(getElementUUIDs);
  const page = yield select(getPage);
  const mappedElements = yield call(customizationElementsMapper, { elementUUIDs, formValues });

  if (customizationUUID && mappedElements && mappedElements.length > 0) {
    const actions = {
      success: ActionTypes.AUTOSAVE_SUCCESS,
      failure: ActionTypes.AUTOSAVE_FAILURE
    };
    const response = yield call(api.customizationUpdate, customizationUUID, { pages: [{ ...page, elements: mappedElements }] }, actions);
    if (response) {
      const responseCustomizationUUID = _get(response, 'payload.customization.result.uuid');
      const responseCustomizationVariationUUID = _get(response, 'payload.customization.result.variation.uuid');
      if (responseCustomizationUUID && responseCustomizationVariationUUID) {
        // This was dispatched on the previous code. not sure why we need to refetch the card
        // dispatch(getCardByVariationUUID(json.variation.uuid, json.uuid)); <--- Before
        yield call(getCardByVariationUUID, responseCustomizationUUID, responseCustomizationVariationUUID);
      }
      // Put response, success or failure (failure is not doing anything with error payload)
      yield put(response);
    }
  }
}



// WEBPACK FOOTER //
// ./src/cards/sagas/customization.js